import { render, staticRenderFns } from "./_base-SideMenu.vue?vue&type=template&id=2de32527&scoped=true&"
import script from "./_base-SideMenu.vue?vue&type=script&lang=js&"
export * from "./_base-SideMenu.vue?vue&type=script&lang=js&"
import style0 from "./_base-SideMenu.vue?vue&type=style&index=0&id=2de32527&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de32527",
  null
  
)

export default component.exports